import { createApi } from "@reduxjs/toolkit/query/react";
import type {
  BeneficiaryPerformanceType,
  EnrolledBeneficiaryType,
} from "../types/beneficiaries";
import { customBaseQuery } from "./customBaseQuery";

export const beneficiaryApi = createApi({
  reducerPath: "beneficiaryApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Beneficiary", "Performance"],
  endpoints: (builder) => ({
    getIndividualBeneficiary: builder.query<EnrolledBeneficiaryType, string>({
      query: (accountNumber) => ({
        url: `/Account/investment-summary-by-benificiary/${accountNumber}`,
      }),
      providesTags: (_result, _error, accountNumber) => [
        { type: "Beneficiary", id: accountNumber },
      ],
    }),
    getBeneficiaryPerformance: builder.query<
      BeneficiaryPerformanceType,
      { userAccountId: string; minorAccountId: string }
    >({
      query: ({ userAccountId, minorAccountId }) => ({
        url: `/Account/support/getmonthlyperformance/${userAccountId}/${minorAccountId}`,
      }),
      providesTags: (_result, _error, { userAccountId, minorAccountId }) => [
        { type: "Performance", id: `${userAccountId}-${minorAccountId}` },
        { type: "Beneficiary", id: minorAccountId },
      ],
    }),
  }),
});

export const {
  useGetIndividualBeneficiaryQuery,
  useGetBeneficiaryPerformanceQuery,
  useLazyGetIndividualBeneficiaryQuery,
  useLazyGetBeneficiaryPerformanceQuery,
} = beneficiaryApi;
